'use client';

import AuthRedirect from '@/components/AuthRedirect';
import LogoLoading from '@/components/LogoLoading';
import { useAppSelector } from '@/redux-store/hooks';
import type { ChildrenType } from '@core/types';

export default function AuthGuard({ children }: ChildrenType) {
    const status = useAppSelector(s => s.auth.status);

    if (status === 'idle' || status === 'loading') {
        return <LogoLoading />;
    }

    return <>{status === 'authenticated' ? children : <AuthRedirect />}</>;
}
